<template>
    <div class="horse-edit-documents flex w-full gap-5 h-full">
        <div class="flex w-full flex-column gap-5">
            <h2 class="page-header">{{ $t('message.horseEdit.history.header') }} ({{ horse.name }})</h2>
            <TabView>
                <TabPanel header="GENERAL">
                    <HorseGeneralHistoryTab :horse="horse"/>
                </TabPanel>
                <TabPanel header="COVERING" v-if="horse.showStallionAgreements" >
                    <HorseCoveringAgreementsHistoryTab :horse="horse" />
                </TabPanel>
                <TabPanel header="COVERING" v-if="horse.showCoveringCertificates">
                    <HorseCoveringCertificatesHistoryTab :horse="horse" />
                </TabPanel>
                <TabPanel header="LABORATORY">
                    <HorseLaboratoryHistoryTab :horse/>
                </TabPanel>
            </TabView>

        </div>
    </div>
</template>

<script>
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import HorseGeneralHistoryTab from "@/views/horse/horseEdit/history/HorseGeneralHistoryTab.vue";
import HorseLaboratoryHistoryTab
    from "@/views/horse/horseEdit/history/HorseLaboratoryHistoryTab.vue";
import HorseCoveringAgreementsHistoryTab from "@/views/horse/horseEdit/history/HorseCoveringHistoryTab.vue"
import HorseCoveringCertificatesHistoryTab
    from "@/views/horse/horseEdit/history/HorseCoveringCertificatesHistoryTab.vue";

export default {
    name: "HorseHistoryView",

    components: {
        HorseLaboratoryHistoryTab,
        HorseGeneralHistoryTab,
        HorseCoveringAgreementsHistoryTab,
        HorseCoveringCertificatesHistoryTab,
        TabPanel,
        TabView
    },

    props: {
        horse: null,
    },

    data() {
        return {
        };
    },
};
</script>

<style lang="scss">
</style>
